let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("80SQE")).then(() => parcelRequire('lKRQ7'));